import { localDate } from '@sales-center/common'
import { normalizeFilters } from '@user/components/Filters'
import {
  SalesFunnelFilterSet,
  FunnelFilterType,
  SalesFunnelSummaryFilterInput,
} from './typings'

export function normalizeSalesFunnelFilters(
  filterSet: SalesFunnelFilterSet,
): SalesFunnelFilterSet {
  const normalized = normalizeFilters<FunnelFilterType, SalesFunnelFilterSet>(
    filterSet,
  )

  const { validKeys, filters } = normalized

  const inputModel: SalesFunnelSummaryFilterInput = {}

  validKeys.map((key) => {
    switch (key) {
      case 'createdDate':
        const { start, end, matchType } = filters[key].value
        const startDate = localDate(start)
        const endDate = localDate(end)
        if (matchType === 'bt') {
          inputModel.fromCreatedDate = startDate ?? undefined
          inputModel.toCreatedDate = endDate ?? undefined
        } else if (matchType === 'gt') {
          inputModel.fromCreatedDate = startDate ?? undefined
        } else if (matchType === 'lt') {
          inputModel.toCreatedDate = startDate ?? undefined
        }
        break
      case 'salesTeamIds':
        const { value: salesTeamIds } = filters[key]
        inputModel.salesTeamMode = salesTeamIds.mode
        inputModel.salesTeamIds = salesTeamIds.options
          .filter(Boolean)
          .map((o) => Number(o.value))
        break
      case 'ownerIds':
        const { value: ownerIds } = filters[key]
        if (!!ownerIds) {
          inputModel.ownerMode = ownerIds.mode
          inputModel.ownerIds = ownerIds.options
            .filter(Boolean)
            .map((o) => o.value as string)
        }
        break
      case 'type':
        const { value: type } = filters[key]
        if (!!type) {
          inputModel.typeMode = type.mode
          inputModel.type = type.options
            .filter(Boolean)
            .map((o) => o.value as string)
        }
        break
      case 'salesFunnelIds':
        const { value: funnelIds } = filters[key]
        inputModel.salesFunnelIds = funnelIds.options
          .filter(Boolean)
          .map((o) => Number(o.value))
        break
    }
  })

  return {
    ...normalized,
    normalizedFilters: [],
    orderBy: '',
    inputModel,
  }
}
